import dayjs from "dayjs";

export const rangeFilters = [
  { from: "fromCost", to: "toCost", type: "number" },
  { from: "fromSOH", to: "toSOH", type: "number" },
  { from: "fromAmount", to: "toAmount", type: "number" },
  { from: "fromDate", to: "toDate", type: "date" },
];

//invoice numbers from orderData
export const getInvoiceNumbersFromOrder = (orderData) => {
  if (!orderData?.orderItems?.length) return [];

  return orderData.orderItems.map(item => item?.invoiceDetails?.invoiceNumber || item?.invoiceNumber)
    .filter(Boolean);
};

//paid invoices from API response
export const extractPaidInvoices = (apiResponse = []) => {
  const result = [];

  apiResponse.forEach(user => {
    const invoices = user?.removedInvoices || user?.removedinvoices || [];
    if (!Array.isArray(invoices)) return;
    invoices.forEach(inv => {
      result.push({
        userId: `${user.userId}`,
        invoiceNo: inv.invoiceNumber,
        paidBy: `user-${inv.customerName}`,
        emailAddress: `${inv.emailAddress}`
      });
    });
  });

  return result;
};

//enums for brand
export const BrandDisplayType = Object.freeze({
  LOGO_ONLY: 'LogoOnly',
  NAME_ONLY: 'NameOnly',
  LOGO_AND_NAME: 'LogoandName',
  NO_DISPLAY: 'NoDisplay',
});

export function isWithinHours(inputDate, difHr) {
  if (!inputDate || typeof difHr !== "number") return false;

  const givenDate = dayjs(inputDate);
  const now = dayjs();

  // If current time is greater than inputDate → false
  if (now.isAfter(givenDate)) return false;

  // Difference in hours (future only)
  const diffInHours = givenDate.diff(now, "hour", true);

  return diffInHours <= difHr;
}

//maintenance
export const isWithinMaintenanceTimeWindow = (startTime, endTime) => {
  if (!startTime || !endTime) return false;

  const now = dayjs();
  const start = dayjs(startTime);
  const end = dayjs(endTime);

  return (
    (now.isAfter(start) || now.isSame(start)) &&
    (now.isBefore(end) || now.isSame(end))
  );
}

export const isMaintenanceStartingSoon = (startTime, minutes = 5) => {
  if (!startTime) return false;
  const now = dayjs();
  const start = dayjs(startTime);
  if (now.isAfter(start)) return false;
  const diffMinutes = start.diff(now, "minute", true);

  return diffMinutes <= minutes;
};

//----------- shipping logic start -----------

// for dailyWorkCd_CDEYWS fields values are 
    // 1--working day 
    // 2-- weekend 
    // 3 --Holiday

// Convert API calendar entry to Dayjs date (America/Chicago timezone)    
export const toDayjsDate = (entry) => {
  if (!entry) return null;

  const paddedMmdd = entry.calendarDtMmdd_MMDYWS.toString().padStart(4, "0");
  const month = paddedMmdd.slice(0, 2);
  const day = paddedMmdd.slice(2);

  return dayjs.tz(
    `${entry.calendarDtYyyy_YYYYWS}-${month}-${day}`,
    "America/Chicago"
  );
};

// Get all working dates (dailyWorkCd_CDEYWS === 1) as YYYY-MM-DD keys
export const getEnabledDateKeys = (calendarData) => {
  if (!Array.isArray(calendarData)) return new Set();

  return new Set(
    calendarData
      .filter((entry) => entry.dailyWorkCd_CDEYWS === 1)
      .map((entry) => toDayjsDate(entry)?.format("YYYY-MM-DD"))
      .filter(Boolean)
  );
};

//----------- shipping logic end -----------